import PageLoadTable from './PageLoadTable'

export default PageLoadTable
